import { render } from "./EditCheckBox.vue?vue&type=template&id=386e9cde&scoped=true"
import script from "./EditCheckBox.vue?vue&type=script&lang=js"
export * from "./EditCheckBox.vue?vue&type=script&lang=js"

import "./EditCheckBox.vue?vue&type=style&index=0&id=386e9cde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386e9cde"]])

export default __exports__